import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { HttpClient } from '@angular/common/http';
import { EmailDomains } from '../model/email-domains.model';

@Injectable({
    providedIn: 'root'
})
export class EmailDomainsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(): Observable<any> {
        return this.get<any>(EndPoints.emailDomains_Index).pipe(
            switchMap((result: any) => {
                return of(result);
            }),
            catchError((err: any) => {
                return throwError(() => new Error(err));
            })
        );
    }

    search(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.emailDomains_Search, false, '', {
            searchString: searchString
        }).pipe(
            switchMap((result: any) => {
                return of(result);
            }),
            catchError((err: any) => {
                return throwError(() => new Error(err));
            })
        );
    }

    createEmailDomain(emailDomain: EmailDomains): Observable<any> {
        return this.post<any>(EndPoints.emailDomains_Create, false, '', {
            newEmailDomain: emailDomain
        }).pipe(
            switchMap((result: any) => {
                return of(result);
            }),
            catchError((err: any) => {
                return throwError(() => new Error(err));
            })
        );
    }

    updateEmailDomain(emailDomain: EmailDomains): Observable<any> {
        return this.post<any>(EndPoints.emailDomains_Update, false, '', {
            editEmailDomain: emailDomain
        }).pipe(
            switchMap((result: any) => {
                return of(result);
            }),
            catchError((err: any) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteEmailDomain(emailDomain: EmailDomains): Observable<any> {
        return this.post<any>(EndPoints.emailDomains_Delete, false, '', {
            deleteEmailDomain: emailDomain
        }).pipe(
            switchMap((result: any) => {
                return of(result);
            }),
            catchError((err: any) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
